// extracted by mini-css-extract-plugin
export default {"item":"nFy0on_5S4","avatar":"xeZ52H6ux4","name":"ID5J4lcJP5"};